import { jsx as _jsx } from "react/jsx-runtime";
import { EmptyState } from "@madmedical/ui";
const PageNotFound = () => _jsx(EmptyState, { title: "Page Not Found" });
export default PageNotFound;
